import { useSession } from "@outschool/ui-auth";
import React from "react";

import { useRequiresMembershipForEnrollment } from "../subscriptions/hooks/useRequiresMembershipForEnrollment";
import FirstMonthFreeBanner from "./FirstMonthFreeBanner";
import ReferralSignupBanner from "./ReferralSignupBanner";

// Use this for running experiments and diverting user cohorts to different membership banners.
export default function MembershipsBannerSwitcher() {
  const { isLoggedIn } = useSession();

  const { mustPurchaseMembership } = useRequiresMembershipForEnrollment();

  // Top level user audience filters, banners will also do their own page-specific display filters.
  const firstMonthFreeUsers = !isLoggedIn || mustPurchaseMembership;

  if (firstMonthFreeUsers) {
    return <FirstMonthFreeBanner />;
  } else if (isLoggedIn) {
    // if not eligible for first month free banner, but still signed up, show referral signup banner
    return <ReferralSignupBanner />;
  } else {
    return null;
  }
}
